module.exports = __webpack_public_path__ + "static/media/promo-banner.4aa7013a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/promo-banner.png
// module id = 412
// module chunks = 1